module.exports = {"130272101":"汉丰镇","130272451":"兴农街道","130272452":"振兴街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130272.json
// module id = 179
// module chunks = 0